import React from "react";

const ContactSection = () => {
  return (
    <>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1,
          }}
        ></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact Us</h1>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="contact-area-2 space-top" id="contact-sec">
        <div className="container">
          <div className="title-area text-center">
            <h2 className="sec-title">Our Contact Information</h2>
          </div>

          <div className="row gy-4 justify-content-center">

            {/* Phone */}
            <div className="col-xl-4 col-lg-4 col-md-4 contact-feature-wrap">
              <div className="contact-feature">

                <div className="contact-feature-icon">
                  <i className="fa-solid fa-phone"></i>
                </div>

                <div className="media-body">
                  <p className="contact-feature_label">Call Us</p>

                  <a href="tel:+919272511548" className="contact-feature_link">
                    +91 9272511548
                  </a>

                  <a href="tel:+917796772627" className="contact-feature_link">
                    +91 77967 72627
                  </a>
                </div>

              </div>
            </div>

            {/* Email */}
            <div className="col-xl-4 col-lg-4 col-md-4 contact-feature-wrap">
              <div className="contact-feature">

                <div className="contact-feature-icon">
                  <i className="fa-solid fa-envelope"></i>
                </div>

                <div className="media-body">
                  <p className="contact-feature_label">Email Us</p>

                  <a
                    href="mailto:booking@risingcabservice.com"
                    className="contact-feature_link"
                  >
                    booking@risingcabservice.com
                  </a>

                </div>

              </div>
            </div>

            {/* Address */}
            <div className="col-xl-4 col-lg-4 col-md-4 contact-feature-wrap">
              <div className="contact-feature">

                <div className="contact-feature-icon">
                  <i className="fa-solid fa-location-dot"></i>
                </div>

                <div className="media-body">
                  <p className="contact-feature_label">Office Address</p>

                  <span className="contact-feature_link">
                    Rising Cab Service<br />
                    A Unit of Atithya Dining LLP,<br />
                    901, 902 Deron Height, Baner Rd,<br />
                    Above Ranka Jewelers, Pune,<br />
                    Maharashtra - 411069
                  </span>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </>
  );
};

export default ContactSection;